import { fetchAccount } from "@/services/account.queries";
import { useToastNotify } from "@/stores/toastStore";
import { getValueFromStorage } from "@/utils/secureStore";
import { useQuery } from "@tanstack/react-query";
import { useT } from "@transifex/react";
import { useState } from "react";
import { useRefreshOnFocus } from "./useRefreshOnFocus";

export function useAccount() {
  const { notify } = useToastNotify();
  const [errorNotified, setErrorNotified] = useState(false);
  const t = useT();

  const { data, isPending, isFetching, error, isSuccess, refetch } = useQuery({
    queryKey: ["account"],
    queryFn: async () => {
      const idToken = await getValueFromStorage("idToken");
      if (idToken && idToken.length > 0) {
        return await fetchAccount({ cognitoIDToken: idToken || "" });
      }
      return null;
    },
  });

  useRefreshOnFocus(refetch);

  if (error && !errorNotified) {
    notify({
      severity: "error",
      message: t("An error occurred when fetching account data"),
    });
    console.error("Error fetching account data:", error);
    setErrorNotified(true);
  }
  if (!error && errorNotified) {
    setErrorNotified(false);
  }

  return {
    account: data,
    isPending,
    isFetching,
    isSuccess,
    refetch,
  };
}
